import { render } from "./Slider.vue?vue&type=template&id=0ae9a65a"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=0ae9a65a&lang=css"

import exportComponent from "C:\\Users\\rob\\Documents\\Websites\\GREENBOOK FEB23\\Update Clinic Services\\FILES\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__